<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <div class="content" v-if="choozeTableData.length > 0">
            <span>{{ $t('integration.please') }}</span> {{ choozeTableData[0].carrierName }} {{ choozeTableData[0].record_date }}
            <span>{{ $t('integration.approval_of_record_points') }}</span>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="resolveFn(1)">{{ $t('integration.adopt') }}</el-button>
            <el-button type="primary" @click="resolveFn(0)">{{ $t('integration.refuse') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { carrierUpdateBatch } from '@/api/modules/record.js';
export default {
    props: ['isShow', 'title', 'choozeTableData'],
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val);
            }
        }
    },
    methods: {
        resolveFn(num) {
            let ids = this.choozeTableData.map(item => {
                return {
                    id: item.id,
                    approve: num
                };
            });
            carrierUpdateBatch(ids).then(({ state }) => {
                if (state.code === 200) {
                    this.$message.success($t('integration.approved_successfully'));
                    this.isShowDialog = false;
                    this.$parent.getListFn();
                } else {
                    this.$message.error(state.msg);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    margin-left: 140px;
}
</style>
